import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Tag } from '@chakra-ui/react';
import { InputElementContent } from '@forest/forms';
import { observer, useField } from '@formily/react';
import { isArr, isValid } from '@formily/shared';
import { createContext, useContext, useEffect, useState } from 'react';
const PlaceholderContext = createContext('N/A');
const Placeholder = PlaceholderContext.Provider;
const usePlaceholder = (value) => {
    const placeholder = useContext(PlaceholderContext) || 'N/A';
    return isValid(value) && value !== '' ? value : placeholder;
};
const ElementWrapper = ({ content, size = 'md' }) => {
    return content ? (_jsx(Box, Object.assign({ fontSize: size, color: "gray.400", pointerEvents: "none" }, { children: _jsx(InputElementContent, { content: content }) }))) : null;
};
const Input = (props) => {
    const { prefix, suffix, size } = props;
    return (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center" }, { children: [_jsx(ElementWrapper, { size: size, content: prefix }), _jsx(Box, { children: usePlaceholder(props.value) }), _jsx(ElementWrapper, { size: size, content: suffix })] })));
};
const Select = observer((props) => {
    const [dataSource, setDataSource] = useState([]);
    const field = useField();
    const placeholder = usePlaceholder();
    useEffect(() => {
        var _a, _b;
        if ((_a = field === null || field === void 0 ? void 0 : field.dataSource) === null || _a === void 0 ? void 0 : _a.length) {
            setDataSource(field.dataSource);
        }
        else if (typeof (props === null || props === void 0 ? void 0 : props.options) === 'function') {
            props === null || props === void 0 ? void 0 : props.options().then((data) => setDataSource(data));
        }
        else {
            setDataSource((_b = props === null || props === void 0 ? void 0 : props.options) !== null && _b !== void 0 ? _b : []);
        }
    }, [field === null || field === void 0 ? void 0 : field.dataSource, props === null || props === void 0 ? void 0 : props.options]);
    const getSelected = () => {
        const value = props.value;
        if (props.mode === 'multiple' || props.mode === 'tags') {
            return isArr(value) ? value.map((val) => ({ label: val, value: val })) : [];
        }
        else {
            return isValid(value) ? [{ label: value, value }] : [];
        }
    };
    const getLabel = (target) => {
        var _a;
        const labelKey = 'label';
        return (((_a = dataSource === null || dataSource === void 0 ? void 0 : dataSource.find((item) => {
            const valueKey = 'value';
            return item[valueKey] === (target === null || target === void 0 ? void 0 : target.value);
        })) === null || _a === void 0 ? void 0 : _a[labelKey]) ||
            target.label ||
            placeholder);
    };
    const getLabels = () => {
        const selected = getSelected();
        if (!selected.length)
            return placeholder;
        if (selected.length === 1)
            return getLabel(selected[0]);
        return selected.map((item, key) => {
            return _jsx(Tag, { children: getLabel(item) }, key);
        });
    };
    return (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center" }, { children: [_jsx(ElementWrapper, { size: props.size, content: props.prefix }), _jsx(Box, { children: getLabels() })] })));
});
// const TreeSelect: React.FC<React.PropsWithChildren<TreeSelectProps<any>>> =
//   observer((props) => {
//     const field = useField<Field>();
//     const placeholder = usePlaceholder();
//     const prefixCls = usePrefixCls('form-text', props);
//     const dataSource = field?.dataSource?.length
//       ? field.dataSource
//       : props?.treeData?.length
//       ? props.treeData
//       : [];
//     const getSelected = () => {
//       const value = props.value;
//       if (props.multiple) {
//         if (props.labelInValue) {
//           return isArr(value) ? value : [];
//         } else {
//           return isArr(value)
//             ? value.map((val) => ({ label: val, value: val }))
//             : [];
//         }
//       } else {
//         if (props.labelInValue) {
//           return value ? [value] : [];
//         } else {
//           return value ? [{ label: value, value }] : [];
//         }
//       }
//     };
//     const findLabel = (
//       value: any,
//       dataSource: any[],
//       treeNodeLabelProp?: string
//     ) => {
//       for (let i = 0; i < dataSource?.length; i++) {
//         const item = dataSource[i];
//         if (item?.value === value) {
//           return item?.label ?? item[treeNodeLabelProp];
//         } else {
//           const childLabel = findLabel(value, item?.children, treeNodeLabelProp);
//           if (childLabel) return childLabel;
//         }
//       }
//     };
//     const getLabels = () => {
//       const selected = getSelected();
//       if (!selected?.length) return <Tag>{placeholder}</Tag>;
//       return selected.map(({ value, label }, key) => {
//         return (
//           <Tag key={key}>
//             {findLabel(value, dataSource, props.treeNodeLabelProp) ||
//               label ||
//               placeholder}
//           </Tag>
//         );
//       });
//     };
//     return (
//       <div className={cls(prefixCls, props.className)} style={props.style}>
//         {getLabels()}
//       </div>
//     );
//   });
// const Cascader: React.FC<React.PropsWithChildren<CascaderProps<any>>> =
//   observer((props) => {
//     const field = useField<Field>();
//     const placeholder = usePlaceholder();
//     const prefixCls = usePrefixCls('form-text', props);
//     const dataSource: any[] = field?.dataSource?.length
//       ? field.dataSource
//       : props?.options?.length
//       ? props.options
//       : [];
//     const findSelectedItem = (
//       items: DefaultOptionType[],
//       val: string | number
//     ) => {
//       return items.find((item) => item.value == val);
//     };
//     const findSelectedItems = (
//       sources: DefaultOptionType[],
//       selectedValues: Array<string[] | number[]>
//     ): Array<any[]> => {
//       return selectedValues.map((value) => {
//         const result: Array<DefaultOptionType> = [];
//         let items = sources;
//         value.forEach((val) => {
//           const selectedItem = findSelectedItem(items, val);
//           result.push({
//             label: selectedItem?.label ?? '',
//             value: selectedItem?.value,
//           });
//           items = selectedItem?.children ?? [];
//         });
//         return result;
//       });
//     };
//     const getSelected = () => {
//       const val = toArr(props.value);
//       // unified conversion to multi selection mode
//       return props.multiple ? val : [val];
//     };
//     const getLabels = () => {
//       const selected = getSelected();
//       const values = findSelectedItems(dataSource, selected);
//       const labels = values
//         .map((val: Array<DefaultOptionType>) => {
//           return val.map((item) => item.label).join('/');
//         })
//         .join(' ');
//       return labels || placeholder;
//     };
//     return (
//       <div className={cls(prefixCls, props.className)} style={props.style}>
//         {getLabels()}
//       </div>
//     );
//   });
// const DatePicker: React.FC<React.PropsWithChildren<DatePickerProps>> = (
//   props
// ) => {
//   const placeholder = usePlaceholder();
//   const prefixCls = usePrefixCls('form-text', props);
//   const getLabels = () => {
//     const labels = formatMomentValue(props.value, props.format, placeholder);
//     return isArr(labels) ? labels.join('~') : labels;
//   };
//   return <div className={cls(prefixCls, props.className)}>{getLabels()}</div>;
// };
// const DateRangePicker: React.FC<
//   React.PropsWithChildren<DateRangePickerProps>
// > = (props) => {
//   const placeholder = usePlaceholder();
//   const prefixCls = usePrefixCls('form-text', props);
//   const getLabels = () => {
//     const labels = formatMomentValue(props.value, props.format, placeholder);
//     return isArr(labels) ? labels.join('~') : labels;
//   };
//   return (
//     <div className={cls(prefixCls, props.className)} style={props.style}>
//       {getLabels()}
//     </div>
//   );
// };
// const TimePicker: React.FC<React.PropsWithChildren<TimePickerProps>> = (
//   props
// ) => {
//   const placeholder = usePlaceholder();
//   const prefixCls = usePrefixCls('form-text', props);
//   const getLabels = () => {
//     const labels = formatMomentValue(props.value, props.format, placeholder);
//     return isArr(labels) ? labels.join('~') : labels;
//   };
//   return (
//     <div className={cls(prefixCls, props.className)} style={props.style}>
//       {getLabels()}
//     </div>
//   );
// };
// const TimeRangePicker: React.FC<
//   React.PropsWithChildren<TimeRangePickerProps>
// > = (props) => {
//   const placeholder = usePlaceholder();
//   const prefixCls = usePrefixCls('form-text', props);
//   const getLabels = () => {
//     const labels = formatMomentValue(props.value, props.format, placeholder);
//     return isArr(labels) ? labels.join('~') : labels;
//   };
//   return (
//     <div className={cls(prefixCls, props.className)} style={props.style}>
//       {getLabels()}
//     </div>
//   );
// };
const Text = (props) => {
    return _jsx("div", { children: usePlaceholder(props.value) });
};
Text.Input = Input;
Text.Select = Select;
// Text.TreeSelect = TreeSelect;
// Text.Cascader = Cascader;
// Text.DatePicker = DatePicker;
// Text.DateRangePicker = DateRangePicker;
// Text.TimePicker = TimePicker;
// Text.TimeRangePicker = TimeRangePicker;
Text.Placeholder = Placeholder;
Text.usePlaceholder = usePlaceholder;
// Text.NumberPicker = NumberPicker;
export const PreviewText = Text;
export default PreviewText;
